export default __webpack_public_path__ + "static/media/logo-gray.f65f5011.svg";